import _Search from "@material-ui/icons/esm/Search";
import _Fade from "@material-ui/core/esm/Fade";
import _TextField from "@material-ui/core/esm/TextField";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { messages } from "./SearchBarMessages";
import { useStyles } from "./SearchBarStyles";
import { detectOutsideClick } from "../../../../helpers/detectClick";

var _ref2 = /*#__PURE__*/_jsx(_Search, {});

const SearchBar = _ref => {
  let showSearchBar = _ref.showSearchBar,
      setShowSearchBar = _ref.setShowSearchBar,
      appliedColors = _ref.appliedColors;
  const intl = useIntl();
  const classes = useStyles(appliedColors);
  const refSearchBar = useRef(null);
  detectOutsideClick(refSearchBar, setShowSearchBar);
  return React.createElement("div", {
    className: classes.container,
    ref: refSearchBar
  }, _jsx(_Fade, {
    in: showSearchBar,
    timeout: 350
  }, void 0, _jsx("div", {
    className: classes.search
  }, void 0, _ref2, _jsx(_TextField, {
    placeholder: intl.formatMessage(messages.placeholder),
    className: classes.formControl,
    InputProps: {
      classes: {
        input: classes.input
      },
      disableUnderline: true
    }
  }))));
};

export { SearchBar };